export default __webpack_public_path__ + "static/media/NHLFantasyPromoMobileCardBg@2x.21ccd187.png";